import React from 'react';
import ReactDOM from 'react-dom';
import qs from 'qs';
import axios from 'axios';

import Color from './components/color';
import ChosenColor from './components/chosenColor';
import ColorCountSelect from './components/colorCountSelect';
import CustomColorSet from './components/customColorSet';
import AvailableColors from './components/availableColors';
import ColormakerFooter from './components/colormakerFooter';

import './index.css';

class ColorSetMaker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      isMakingAjaxReq: false,
      colors: [],
      chosenColors: [],
      colorCount: 6,
      price: 0
    };
  }

  componentDidMount() {
    // axios.get('http://localhost:3001/krasas')
    axios.post('https://manasgarsas.lv/wp-admin/admin-ajax.php', qs.stringify({
      action: 'highgrove_get_available_colors'
    }))
      .then((res) => {
        if (res.status === 200) {
          const colors = res.data.map(color => ({
            ...color,
            chosen: false
          }));
          this.setState({
            isLoaded: true,
            colors
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoaded: true,
          error
        });
      });
  }

  handleColorPick(i) {
    if (this.state.chosenColors.length < this.state.colorCount || this.state.colors[i].chosen) {
      const colors = this.state.colors.slice();
      const chosenColors = this.state.chosenColors.slice();
      colors[i].chosen = !colors[i].chosen;
      let price = Number(this.state.price);
      if (colors[i].chosen) {
        chosenColors.push(i);
        price += Math.round(colors[i].price * 40 * 100);
      } else {
        const index = chosenColors.indexOf(i);
        if (index > -1) {
          chosenColors.splice(index, 1);
          price -= Math.round(colors[i].price * 40 * 100);
        }
      }
      this.setState({
        colors,
        chosenColors,
        price
      });
    } else {
      alert(`Jūs jau esat izvēlējies ${this.state.colorCount} krāsas :)`);
    }
  }

  handleColorRemove(i) {
    const colors = this.state.colors.slice();
    const chosenColors = this.state.chosenColors.slice();
    colors[i].chosen = false;
    const index = chosenColors.indexOf(i);
    if (index > -1) chosenColors.splice(index, 1);
    this.setState({
      colors,
      chosenColors
    });
  }

  handleColorCountChange(event) {
    if (event.target.value < this.state.chosenColors.length) {
      const chosenColors = this.state.chosenColors.slice(0, event.target.value);
      const colors = this.state.colors.map((color, i) => {
        if (chosenColors.indexOf(i) === -1) {
          return {
            ...color,
            chosen: false
          };
        }
        return color;
      });
      this.setState({
        colorCount: Number(event.target.value),
        chosenColors,
        colors
      });
    } else {
      this.setState({ colorCount: Number(event.target.value) });
    }
  }

  handleColorSetCreation() {
    if (this.state.chosenColors.length < this.state.colorCount) {
      alert(`Jums jāizvēlas ${this.state.colorCount} krāsas. Šobrīd esat izvēlējies ${this.state.chosenColors.length}.`);
    } else {
      const colorSetData = this.state.chosenColors.map(i => ({
        product_id: this.state.colors[i].ID,
        quantity_mix: 40
      }));
      this.setState({
        isMakingAjaxReq: true
      });
      axios.post('https://manasgarsas.lv/wp-admin/admin-ajax.php', qs.stringify({
        action: 'just_constructor_save',
        product_name: 'Krāsu komplekts',
        spice_constructor_components: JSON.stringify(colorSetData)
      }))
        .then((res) => {
          if (res.status === 200) {
            alert('Krāsu komplekts izveidots veiksmīgi.');
          }
          this.setState({
            isMakingAjaxReq: false
          });
          window.location.href = '/iepirkumu-grozs';
        })
        .catch((error) => {
          alert(`Diemžēl atgadījās kļūda: ${error.message}`);
          this.setState({
            isMakingAjaxReq: false
          });
        });
    }
  }

  render() {
    const { error, isLoaded } = this.state;
    const availableColors = this.state.colors.map((color, i) => (
      <Color
        key={color.ID}
        color={color}
        onClick={() => this.handleColorPick(i)}
      />
    ));
    const chosenColors = this.state.chosenColors.map(i => (
      <ChosenColor
        key={this.state.colors[i].ID}
        color={this.state.colors[i]}
        onClick={() => this.handleColorPick(i)}
      />
    ));

    if (error) {
      return <div>Kļūda: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Lūdzu uzgaidiet! Notiek ielāde&hellip; {isLoaded}!</div>;
    }
    return (
      <div className="colorset-maker__app">
        <ColorCountSelect
          colorCount={this.state.colorCount}
          onChange={ev => this.handleColorCountChange(ev)}
        />
        <AvailableColors colorCount={this.state.colorCount}>
          {availableColors}
        </AvailableColors>
        <CustomColorSet price={this.state.price}>
          {chosenColors}
        </CustomColorSet>
        <ColormakerFooter
          onClick={() => this.handleColorSetCreation()}
          isMakingAjax={this.state.isMakingAjaxReq}
        />
      </div>
    );
  }
}

ReactDOM.render(<ColorSetMaker />, document.getElementById('kn-colorset-maker'));



// WEBPACK FOOTER //
// ./src/index.js